export interface AppConfiguration {
  stage: 'dev' | 'prod' | 'preprod';
  adminAreas: {
    url: string;
  };
  apiUrl: string;
}

export const appConfig = (window as any).CONFIG as AppConfiguration;
